var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('div',{staticClass:"messagebox"},[_c('el-badge',{staticClass:"badge",attrs:{"value":_vm.num,"hidden":!_vm.num,"max":99}},[_c('i',{staticClass:"el-icon-bell",on:{"click":_vm.click}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }